module.exports = __webpack_public_path__ + "img/pills.ca2ec9cf.png";